// extracted by mini-css-extract-plugin
export default {"Box":"Kandidaten_Box__QYbGD","BoxHeader":"Kandidaten_BoxHeader__qumGb"};